import { PropertyDetailsType } from '__core/shared/model/finance/PropertyDetails.enum';
import template from './securityDetails.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    securityDetails: '<',
    assets: '<',
    liabilities: '<',
    fundingWorksheets: '<',
    compliance: '<',
    lenders: '<',
    countries: '<',
    contacts: '<',
    ticketClientTypes: '<',
    validationErrors: '<',
    idWorkflow: '<',
    idTicket: '<',
    ticketOwner: '<',
    isHomeLoanTools: '<',
    isTicketSettled: '<',
    onFinished: '&',
    onDiversificationFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      $mdMedia,
      Address,
      SecurityDetails,
      SecuritySplit,
      ContactForValuation,
      TitleDetail,
      OtherMortgage,
      FundingWorksheet,
      HomeLoanCompliance,
      homeLoanService,
      helperService,
      uiService,
      diversificationOpportunityService,
      OpportunityContextualType,
      CertificateOfTitle,
      PersonalTitle,
      OwnershipType,
      PropertyType,
      TransactionType,
      TypeOfCertificateOfTitle,
      ZoningOption,
      GOOGLEMAPS
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableStates = [];
      ctrl.availableZoneOptions = [];
      ctrl.availableTransactionTypes = [];
      ctrl.availablePropertyTypes = [];
      ctrl.availableOwnershipTypes = [];
      ctrl.availableAssetsForSecurities = [];
      ctrl.availablePersonalTitles = [];
      ctrl.availableOtherContactTypesForValuation = [];
      ctrl.availableTypesOfCertificateOfTitle = [];
      ctrl.availableCertificatesOfTitle = [];
      ctrl.availableMortgagePriorities = [];
      ctrl.showPropertyDetails = [];
      ctrl.isPropertyChanged = [];
      ctrl.propertyDetails = [];
      ctrl.propertyDetails = {};
      ctrl.otherDateFormat = $rootScope.CurrentDateFormatSecondary();
      ctrl.dateFormat = helperService.setOtherDateFormat;
      ctrl.searchTerm = '';
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.googleAutocompleteOptions = {
          componentRestrictions: GOOGLEMAPS.restrictToCountries
        };
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availableZoneOptions = ZoningOption.available();
        ctrl.availableTransactionTypes = TransactionType.available();
        ctrl.availablePropertyTypes = PropertyType.available();
        ctrl.availableOwnershipTypes = OwnershipType.available();
        ctrl.availablePersonalTitles = PersonalTitle.available();
        ctrl.availableOtherContactTypesForValuation =
          helperService.getAvailableOtherContactTypesForValuation();
        ctrl.availableTypesOfCertificateOfTitle = TypeOfCertificateOfTitle.available();
        ctrl.availableCertificatesOfTitle = CertificateOfTitle.available();
        ctrl.availableMortgagePriorities = helperService.getAvailableMortgagePriorities();
        ctrl.securityDetails = ctrl.securityDetails || SecurityDetails.Blank();
        ctrl.assets = ctrl.assets || [];
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.fundingWorksheets = ctrl.fundingWorksheets || {};
        ctrl.compliance = ctrl.compliance || {};
        ctrl.lenders =
          _.chain(ctrl.lenders)
            .filter((l) => l.type.indexOf('RESIDENTIAL') > -1)
            .sortNatural('name')
            .sortNatural('group')
            .value() || [];
        ctrl.countries = ctrl.countries || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.idWorkflow = ctrl.idWorkflow || '';
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.isHomeLoanTools = ctrl.isHomeLoanTools || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.ownership = helperService.setOwnershipOfAssetOrLiability(ctrl.contacts, true);
        ctrl.searchType = '';
        if (ctrl.ticketOwner?.isRpDataEnabled() && !ctrl.ticketOwner.isPriceFinderEnabled()) {
          ctrl.searchType = PropertyDetailsType.rp_data.name;
        }
        if (ctrl.ticketOwner.isPriceFinderEnabled() && !ctrl.ticketOwner?.isRpDataEnabled()) {
          ctrl.searchType = PropertyDetailsType.pricefinder.name;
        }
        if (!ctrl.isTicketSettled) {
          ctrl.setSecurityDetails();
        } else {
          ctrl.isReady = true;
        }
      };

      ctrl.setSecurityDetails = () => {
        if (!ctrl.securityDetails.securitySplits.length) {
          ctrl.securitySplitAdd();
        }
        if (ctrl.assets.length && ctrl.isHomeLoanTools) {
          ctrl.getSetAssetsForSecurities();
        }
        const idSecurities = _.map(ctrl.securityDetails.securitySplits, 'id');
        const idSecurityOfContactsForValuation = _.map(
          ctrl.securityDetails.contactsForValuation,
          'idSecurity'
        );
        const idSecurityOfTitleDetails = _.map(ctrl.securityDetails.titleDetails, 'idSecurity');
        const idSecurityOfOtherMortgages = _.map(
          ctrl.securityDetails.otherMortgages,
          'idSecurity'
        );
        const idSecurityOfFundsRequired = _.map(
          ctrl.fundingWorksheets.fundsRequired,
          'idSecurity'
        );
        const idSecurityOfFundsAvailable = _.map(
          ctrl.fundingWorksheets.fundsAvailable,
          'idSecurity'
        );
        const idSecurityOfOthers = _.uniq(
          _.compact(
            _.union(
              idSecurityOfContactsForValuation,
              idSecurityOfTitleDetails,
              idSecurityOfOtherMortgages,
              idSecurityOfFundsRequired,
              idSecurityOfFundsAvailable
            )
          )
        );
        const unknownIdSecurities = _.difference(idSecurityOfOthers, idSecurities);
        for (let u = 0; u < unknownIdSecurities.length; u += 1) {
          ctrl.otherHomeLoanSecurityDetailsDelete(unknownIdSecurities[u]);
        }
        for (let s = 0; s < ctrl.securityDetails.securitySplits.length; s += 1) {
          if (
            !ctrl.securityDetails.securitySplits[s].ownership ||
            !ctrl.securityDetails.securitySplits[s].ownership.length
          ) {
            ctrl.securityDetails.securitySplits[s].ownership = ctrl.ownership;
          }
        }
        ctrl.isReady = true;
      };

      ctrl.getSetAssetsForSecurities = () => {
        ctrl.availableAssetsForSecurities = ctrl.assets.filter(
          (a) =>
            helperService.isAssetTypeOwnerOccupiedOrInvestment(a.assetType) &&
            a.hasAddress() &&
            a.value !== 0
        );
      };

      ctrl.securitySplitAdd = (security) => {
        let selectedAsset;
        if (security && ctrl.assets.length) {
          selectedAsset = ctrl.assets.find((a) => a.id === security.id);
        }
        let idx = -1;
        if (selectedAsset) {
          if (ctrl.securityDetails.securitySplits instanceof Array) {
            idx = ctrl.securityDetails.securitySplits.findIndex(
              (s) => s.idAsset === selectedAsset.id
            );
          }
        }
        if (idx === -1) {
          if (
            ctrl.securityDetails.securitySplits.length > 0 &&
            ctrl.securityDetails.securitySplits[ctrl.securityDetails.securitySplits.length - 1]
              .idAsset === '' &&
            !ctrl.securityDetails.securitySplits[
              ctrl.securityDetails.securitySplits.length - 1
            ].hasAddress() &&
            ctrl.securityDetails.securitySplits[ctrl.securityDetails.securitySplits.length - 1]
              .value === 0
          ) {
            ctrl.otherHomeLoanSecurityDetailsDelete(
              ctrl.securityDetails.securitySplits[
                ctrl.securityDetails.securitySplits.length - 1
              ].id
            );
            ctrl.securityDetails.securitySplits.splice(
              ctrl.securityDetails.securitySplits.length - 1,
              1
            );
          }
          const securitySplit = SecuritySplit.Blank();
          securitySplit.ownership = ctrl.ownership;
          if (selectedAsset) {
            securitySplit.idAsset = selectedAsset.id;

            securitySplit.address = Address.copy(selectedAsset.address);

            securitySplit.value = selectedAsset.value;
            securitySplit.transactionType =
              homeLoanService.getStatusOfMortgagesOfSelectedSecurity({
                homeLoanOtherMortgages: ctrl.securityDetails?.otherMortgages || [],
                idSecurity: securitySplit?.id || undefined,
                isNew: securitySplit?.isNew || false
              });
            securitySplit.propertyType = selectedAsset.propertyType;
            securitySplit.zoning = selectedAsset.zoning;
            if (
              (helperService.isAssetTypeOwnerOccupied(selectedAsset.assetType) &&
                !selectedAsset.willItBecomeInvestment) ||
              (helperService.isAssetTypeInvestment(selectedAsset.assetType) &&
                selectedAsset.willItBecomeOwnerOccupied)
            ) {
              securitySplit.ownershipType = OwnershipType.owner_occupied;
              securitySplit.monthlyRentalIncome = selectedAsset.monthlyRentalIncome || 0;
              securitySplit.numberOfBoarders = selectedAsset.numberOfBoarders || 0;
              securitySplit.allInclusive = selectedAsset.allInclusive || false;
            } else if (
              (helperService.isAssetTypeOwnerOccupied(selectedAsset.assetType) &&
                selectedAsset.willItBecomeInvestment) ||
              (helperService.isAssetTypeInvestment(selectedAsset.assetType) &&
                !selectedAsset.willItBecomeOwnerOccupied)
            ) {
              securitySplit.ownershipType = OwnershipType.investment;
              securitySplit.monthlyRentalIncome = selectedAsset.monthlyRentalIncome;
            }
            securitySplit.toBeSold = selectedAsset.toBeSold;
            securitySplit.valuation = selectedAsset.valuation;
            securitySplit.ownership = selectedAsset.ownership;
            securitySplit.isPrimary =
              !_.isEmpty(ctrl.securityDetails) &&
              ctrl.securityDetails.securitySplits &&
              ctrl.securityDetails.securitySplits.length === 0;
            securitySplit.propertyDetails = selectedAsset.propertyDetails;
            securitySplit.isNew = false;
          }

          ctrl.securityDetails.securitySplits.push(securitySplit);
          ctrl.contactForValuationAdd(
            ctrl.securityDetails.securitySplits[ctrl.securityDetails.securitySplits.length - 1]
              .id,
            ctrl.contacts[0]?.id
          );
          ctrl.titleDetailAdd(
            ctrl.securityDetails.securitySplits[ctrl.securityDetails.securitySplits.length - 1]
              .id
          );

          if (
            !ctrl.securityDetails.securitySplits[ctrl.securityDetails.securitySplits.length - 1]
              .isNew
          ) {
            ctrl.otherMortgageAdd(
              ctrl.securityDetails.securitySplits[
                ctrl.securityDetails.securitySplits.length - 1
              ].id,
              ctrl.securityDetails.securitySplits[
                ctrl.securityDetails.securitySplits.length - 1
              ].idAsset
            );
          }
          ctrl.saveSecurityDetails(ctrl.securityDetails);
        } else {
          uiService.toast({
            text: {
              p1: 'Asset',
              p2: selectedAsset.getName(),
              p3: 'has already been added'
            },
            warn: true
          });
        }
      };

      ctrl.securitySplitDelete = (security) => {
        helperService
          .deleteItem(
            ctrl.securityDetails.securitySplits,
            security,
            'Security split',
            security.getAddress()
          )
          .then((result) => {
            if (result) {
              ctrl.otherHomeLoanSecurityDetailsDelete(security.id);
            }
          });
      };

      ctrl.isAnyOfSecuritiesSetAsPreferred = () =>
        _.some(ctrl.securityDetails?.securitySplits || [], (s) => s?.isPrimary);

      ctrl.clearSearchTerm = () => {
        ctrl.searchTerm = '';
      };

      ctrl.toggleTransactionType = (securityEdited) => {
        const security = securityEdited;
        if (security?.transactionType?.name === TransactionType.purchase.name) {
          security.isNew = true;
          ctrl.otherMortgageDelete(security.id);
        } else {
          security.isNew = false;
          ctrl.otherMortgageAdd(security.id);
        }
      };

      ctrl.contactForValuationAdd = (idSecurity, idPrimaryClient) => {
        ctrl.securityDetails.contactsForValuation.push(
          ContactForValuation.Blank(idSecurity, idPrimaryClient)
        );
      };

      ctrl.titleDetailAdd = (idSecurity) => {
        ctrl.securityDetails.titleDetails.push(TitleDetail.Blank(idSecurity));
      };

      ctrl.otherMortgageAdd = (idSecurity, idAsset) => {
        const oMortgages = homeLoanService.addHomeLoanOtherMortgage(
          idSecurity,
          idAsset,
          ctrl.securityDetails,
          ctrl.liabilities,
          ctrl.contacts
        );
        if (oMortgages && oMortgages.length) {
          ctrl.securityDetails.otherMortgages = oMortgages;
        }
      };

      ctrl.otherMortgageDelete = (idSecurity) => {
        for (let o = 0; o < ctrl.securityDetails.otherMortgages.length; o += 1) {
          if (ctrl.securityDetails.otherMortgages[o].idSecurity === idSecurity) {
            ctrl.securityDetails.otherMortgages.splice(o, 1);
          }
        }
      };

      ctrl.otherMortgageSingleDelete = (idx) => {
        ctrl.securityDetails.otherMortgages.splice(idx, 1);
      };

      ctrl.getLastIndex = (idSecurity) =>
        _.findLastIndex(ctrl.securityDetails.otherMortgages, { idSecurity });

      ctrl.hasPropertyDetails = (propertyDetails) =>
        !_.isEmpty(propertyDetails) &&
        propertyDetails?.type?.name === ctrl.searchType &&
        propertyDetails?.idOwner === ctrl.ticketOwner?.id;

      ctrl.changeProperty = (data) => {
        const idx = _.findIndex(
          ctrl.securityDetails?.securitySplits || [],
          (s) => s?.id === data?.id
        );
        if (idx > -1) {
          ctrl.showPropertyDetails[idx] = data?.isReady;
          ctrl.isPropertyChanged[idx] = !data?.isReady;
        }
      };

      ctrl.setPropertyData = (data) => {
        const idx = _.findIndex(
          ctrl.securityDetails?.securitySplits || [],
          (s) => s?.id === data?.id
        );
        if (idx > -1) {
          ctrl.propertyDetails[idx] = data?.propertyDetails;
          ctrl.saveSecurityDetails(null, null, null, true);
        }
      };

      ctrl.toggleOwnershipType = (data) => {
        const security = data;
        if (security.ownershipType !== 2) {
          security.monthlyRentalIncome = 0;
        }
        ctrl.saveSecurityDetails(ctrl.securityDetails);
      };

      ctrl.otherHomeLoanSecurityDetailsDelete = (idSecurity) => {
        const data = homeLoanService.otherHomeLoanSecurityDetailsDelete(
          idSecurity,
          ctrl.securityDetails,
          ctrl.fundingWorksheets
        );
        ctrl.securityDetails = data.securityDetails;
        ctrl.fundingWorksheets = data.fundingWorksheets;
        ctrl.saveSecurityDetails(ctrl.securityDetails, ctrl.fundingWorksheets);
      };

      ctrl.isStateValid = (state) => helperService.isStateValid(state);

      ctrl.getSecurity = (idSecurity) => {
        let securitySplit;
        if (ctrl.securityDetails.securitySplits.length) {
          securitySplit = ctrl.securityDetails.securitySplits.find((s) => s.id === idSecurity);
        }
        return securitySplit;
      };

      ctrl.toggleContactForValuation = (idSecurity) => {
        for (let c = 0; c < ctrl.securityDetails.contactsForValuation.length; c += 1) {
          if (ctrl.securityDetails.contactsForValuation[c].idSecurity === idSecurity) {
            if (ctrl.securityDetails.contactsForValuation[c].isOther) {
              ctrl.securityDetails.contactsForValuation[c].loanParty = [];
              ctrl.saveSecurityDetails(ctrl.securityDetails);
            } else {
              ctrl.securityDetails.contactsForValuation[c].other.companyName = '';
              ctrl.securityDetails.contactsForValuation[c].other.title = 0;
              ctrl.securityDetails.contactsForValuation[c].other.firstName = '';
              ctrl.securityDetails.contactsForValuation[c].other.surname = '';
              ctrl.securityDetails.contactsForValuation[c].other.phone = '';
              ctrl.securityDetails.contactsForValuation[c].other.type = 0;
              ctrl.securityDetails.contactsForValuation[c].address = Address.blank();
              if (ctrl.contacts.length) {
                ctrl.securityDetails.contactsForValuation[c].loanParty.push(
                  ctrl.contacts[0].id
                );
                ctrl.saveSecurityDetails(ctrl.securityDetails);
              }
            }
          }
        }
      };

      ctrl.editOwnership = ($event, security) =>
        helperService
          .editOwnershipOfAssetOrLiability({
            event: $event,
            item: security,
            contacts: ctrl.contacts,
            isDisabled: ctrl.isTicketSettled
          })
          .then((result) => {
            if (result) {
              const idx = helperService.findIndexById(
                ctrl.securityDetails.securitySplits,
                result.id
              );
              if (idx > -1) {
                ctrl.securityDetails.securitySplits[idx].ownership = result.ownership;
                ctrl.saveSecurityDetails(ctrl.securityDetails);
              }
            }
          });

      ctrl.getContact = (idContact) => {
        let contact;
        if (ctrl.contacts.length) {
          contact = ctrl.contacts.find((c) => c.id === idContact);
        }
        return contact;
      };

      ctrl.getLiability = (idLiability) => {
        let liability;
        if (ctrl.liabilities.length) {
          liability = ctrl.liabilities.find((c) => c.id === idLiability);
        }
        return liability;
      };

      ctrl.isLiabilityTypeMortgageOrSmsfLoan = (liability) => {
        if (liability) {
          return helperService.isLiabilityTypeMortgageOrSmsfLoan(liability.liabilityType);
        }
        return null;
      };

      ctrl.isLenderSelected = (mortgage) => {
        if (mortgage.lender !== '') {
          return (
            _.find(ctrl.lenders, (l) => l.abbr.toLowerCase() === mortgage.lender) !== undefined
          );
        }
        return true;
      };

      ctrl.toggleLimitedSecurity = ({ security }) => {
        const sec = security;
        if (!sec?.isLimited) {
          sec.guaranteeAmount = 0;
        }
        ctrl.saveSecurityDetails();
      };

      ctrl.showLimitedSecurityOption = ({ security }) =>
        homeLoanService.getStatusOfSecurityLimitedOption({
          contacts: ctrl.contacts,
          ticketClientTypes: ctrl.ticketClientTypes,
          security
        });

      ctrl.showWarning = (security) => {
        const collections = [];
        if (
          ctrl.organizationCountry.cca2 === 'AU' &&
          security?.address?.country === 'Australia'
        ) {
          collections.push(
            !security?.address?.streetNumber,
            !security?.address?.street,
            !security?.address?.suburb,
            !security?.address?.state,
            !security?.address?.postCode,
            !security?.address?.country
          );
        }
        collections.push(!security?.value);
        return _.some(collections, (c) => c === true);
      };

      ctrl.isAssetExisting = (idAsset) =>
        _.find(ctrl.assets || [], (a) => a?.id === idAsset) !== undefined;

      ctrl.isThereAnyNewOwnerOccupied = () =>
        _.some(
          ctrl.securityDetails?.securitySplits,
          (s) => s?.ownershipType?.name === OwnershipType.owner_occupied.name && s?.isNew
        );

      ctrl.isThereAnyNewInvestment = () =>
        _.some(
          ctrl.securityDetails?.securitySplits,
          (s) => s?.ownershipType?.name === OwnershipType.investment.name && s?.isNew
        );

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.saveSecurityDetails = (
        securityDetails,
        fundingWorksheets,
        compliance,
        isPropertyDataChanged
      ) => {
        const data = {};
        if (securityDetails instanceof SecurityDetails) {
          data.securityDetails = securityDetails;
        }
        if (fundingWorksheets instanceof FundingWorksheet) {
          data.fundingWorksheets = fundingWorksheets;
        }
        if (compliance instanceof HomeLoanCompliance) {
          data.compliance = compliance;
        }
        if (_.isEmpty(data) && !isPropertyDataChanged) {
          data.securityDetails = ctrl.securityDetails;
        }
        if (_.isEmpty(data) && isPropertyDataChanged) {
          data.isPropertyDataChanged = true;
        }
        ctrl.onFinished({ data });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
